import Unlock from './components/Unlock'

import {GlobalStyle} from './styledComponents'

const App = () => (
  <>
    <GlobalStyle />
    <Unlock />
  </>
)

export default App
